import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <p>No match</p>
            <img src="Images/share.png" alt="" />
        </div>
    );
};

export default NoMatch;